import ServerDateService from 'Faster/service/ServerDateService';

const MINIMAL_DIFFERENCE_IN_MILLISECONDS = 400;
class ServerDate {
  public offset: number;
  private serverDateService: ServerDateService;
  public static instance: ServerDate;
  private isActive: boolean;

  private constructor(serverDateService: ServerDateService) {
    this.serverDateService = serverDateService;
    this.isActive = false;
  }

  public static getInstance(serverDateService: ServerDateService): ServerDate {
    if (!ServerDate.instance) {
      ServerDate.instance = new ServerDate(serverDateService);
    }
    return ServerDate.instance;
  }

  public static now(): Date {
    try {
      if (typeof this.instance === undefined) {
        throw Error('Server Date not initialized yet, unable to provide a ntp Date');
      }

      if (typeof this.instance.offset === undefined) {
        throw Error('Server Date not synchronized yet, unable to provide a ntp Date');
      }

      const localTimeWithOffSet = new Date().getTime() + this.instance.offset;
      return new Date(localTimeWithOffSet);
    } catch (err) {
      return null;
    }
  }

  public sync(): void {
    this.syncIfNeeded();
  }

  private syncIfNeeded(): void {
    if (this.isActive === true) {
      return;
    }
    if (this.offset !== undefined) {
      return;
    }

    this.isActive = true;
    this.getServerTime().then((serverTime): void => {
      const timeDifference = serverTime - new Date().getTime();
      if (serverTime === 0 || Math.abs(timeDifference) <= MINIMAL_DIFFERENCE_IN_MILLISECONDS) {
        this.offset = 0;
        return;
      }
      this.offset = timeDifference;
      this.isActive = false;
    });
  }

  private async getServerTime(): Promise<number> {
    const numberOfRequests = 3;
    const requests = Array(numberOfRequests).fill((): Promise<Date> => this.serverDateService.get());

    const responses = await Promise.all(requests.map((promise) => promise()));
    const serverDates = responses.filter((res): boolean => res !== undefined);

    if (serverDates.length === 0) {
      console.warn('It was not possible to retrieve a date from server, faster  will use the localtime');
      return 0;
    }

    const serverTimes = serverDates.map((date): number => date.getTime());
    const minTime = Math.min(...serverTimes);
    return minTime;
  }

  public static clear() {
    ServerDate.instance = null;
  }
}
export default ServerDate;
